import { z } from "zod";
export const SessionSchema = z.object({
    id: z.string(),
    scheduledStart: z.iso.datetime(),
    practitionerId: z.string(),
    practitionerFirstName: z.string(),
    contacts: z.array(z.object({ id: z.string(), firstName: z.string() })),
});
export const SessionsResponseSchema = z.object({
    sessions: SessionSchema.array(),
});
